import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga4";

declare global {
    interface Window {
        gtag: (...args: any[]) => void;
    }
}

declare const gtag: (...args: any[]) => void;

const FacebookPixelUtil = {
    Initialize(facebookPixelId: string, ga4MeasurementId: string) {
        ReactPixel.init(facebookPixelId);
        ReactGA.initialize(ga4MeasurementId);
    },

    PageView() {
        ReactPixel.pageView();
    },

    TrackViewHomepage() {
        ReactPixel.fbq("track", "NT-Homepage-View");
        ReactGA.event("NT-Homepage-View");
    },

    TrackHomepageRegisterButtonClicked() {
        ReactPixel.fbq("track", "NT-Homepage-Register-Button-Clicked");
        ReactGA.event("NT-Homepage-RegisterButton-Clicked");
    },

    TrackLoginButtonClicked() {
        ReactPixel.fbq("track", "NT-Homepage-Login-Button-Clicked");
        ReactGA.event("NT-Homepage-LoginButton-Clicked");
    },

    TrackSupportLinkClicked() {
        ReactPixel.fbq("track", "NT-SupportLink-Clicked");

        ReactGA.event("NT-SupportLink-Clicked");
    },

    TrackViewProduct(productCode: string, productName: string) {
        ReactPixel.trackCustom("NT-ViewProduct", { product_code: productCode, product_name: productName });

        ReactGA.event("NT-ViewProduct", { product_code: productCode, product_name: productName });
    },

    TrackInitialCheckout(productCode: string, productName: string) {
        ReactPixel.trackCustom("NT-InitialCheckout", { product_code: productCode, product_name: productName });

        ReactGA.event("NT-InitialCheckout", { product_code: productCode, product_name: productName });
    },

    TrackCheckedOut(productCode: string, productName: string) {
        ReactPixel.trackCustom("NT-Checkedout", { product_code: productCode, product_name: productName });
        ReactGA.event("NT-Checkedout", { product_code: productCode, product_name: productName });
        ReactGA.event("conversion", { send_to: 'AW-17778983344/cVCcCIq0scwbELCD151C' });
    },

    TrackPurchased(amount: any, invoiceNo: any) {
        ReactGA.event("NT-Purchased", { invoiceNo: invoiceNo });
        //ReactGA.event("conversion", {
        //    send_to: 'AW-17778983344/cVCcCIq0scwbELCD151C',
        //    value: amount,
        //    currency: 'IDR',
        //    transaction_id: String(invoiceNo)
        //});
        if (typeof gtag !== "undefined") {
            gtag('event', 'conversion', {
                send_to: 'AW-17778983344/D4G9CM3gsswbELCD151C',
                value: amount,
                currency: 'IDR',
                transaction_id: String(invoiceNo)
            });
        } else {
            console.error("gtag not loaded");
        }
    }
};

export default FacebookPixelUtil;